import {ActiveRecord} from './ActiveRecord';
import config from 'config';
import {UserRole} from "../types";
import ValidationError from "../utilites/networkErrors/ValidationError";

export const MANAGER_ROLE_PRODUCT = 'product_manager';
export const MANAGER_ROLE_EVENT = 'event_manager';

export interface UserDTO {
  first_name: string;
  last_name: string;
}

const roles = [
  {
    label: 'Product manager',
    value: MANAGER_ROLE_PRODUCT
  },
  {
    label: 'Event manager',
    value: MANAGER_ROLE_EVENT
  }
];

class Manager extends ActiveRecord {
  static path = `${config.backOfficeBasePath}/managers`;

  static validateConstraints = {

    first_name: {
      presence: true,
      length: {
        minimum: 2
      }
    },

    last_name: {
      presence: true,
      length: {
        minimum: 2
      }
    },

    email: {
      presence: true,
      email: true
    },

    role: {
      presence: true,
      inclusion: roles.map(item => item.value)
    },

    password: {
      // password: true
    },

    club_id: {
      presence: false
    }

  };

  static roles = roles;

  role: string;

  static mapRecords(data) {
    return data.map((item) => new Manager(item));
  }

  _getModel() {
    return Manager;
  }

  protected async _updateRecord(dataForSave) {
    return await this._networkLayer.patchJSON(`${config.backOfficeBasePath}/profile/${this.id}`, dataForSave);
  }

  get userRole(): UserRole {
    switch(this.role) {
      case MANAGER_ROLE_PRODUCT:
        return 'PM';
      default:
        return 'EM';
    }
  }

  async checkValidateResponse(e) {
    try {
      await super.checkValidateResponse(e);
    }
    catch (err) {
      let emailNotUniqueError = err.email.find((message) => message.msg === 'error.not_unique');

      if (emailNotUniqueError) {
        emailNotUniqueError.msg = 'error.not_unique_user_email';
      }
      throw err;
    }
  }

}

export default Manager;



// WEBPACK FOOTER //
// ./src/api/manager.ts